import { GearSixIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { Settings } from "../../components/settings"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"

const useBreadcrumb = (t: (key: string) => string) => [
  { to: "/", label: t("common:breadcrumb.home") },
  { label: t("settings:page.title") },
]

export function SettingsPage() {
  const { t } = useTranslation(["delivery", "common", "settings"])
  // Every settings read needs one of these (BE contract §1); writes are gated per tab.
  const govView = usePermission("BIZ_GOV_VIEW")
  const sizeMng = usePermission("LOG_SIZE_MNG")
  const classMng = usePermission("LOG_CLASS_RULE_MNG")
  const canView = govView.hasAccess || sizeMng.hasAccess || classMng.hasAccess
  const breadcrumbs = useBreadcrumb(t)

  return (
    <PageLayout
      icon={<GearSixIcon size={22} />}
      title={t("settings:page.title")}
      subTitle={t("settings:page.subtitle")}
      breadcrumb={breadcrumbs}
    >
      {canView ? <Settings /> : govView.accessDenied()}
    </PageLayout>
  )
}
